__turbopack_context__.v({
  "accordionSlideOverwrite": "quizButton-module-scss-module__ykarya__accordionSlideOverwrite",
  "button": "quizButton-module-scss-module__ykarya__button",
  "destructive": "quizButton-module-scss-module__ykarya__destructive",
  "endIcon": "quizButton-module-scss-module__ykarya__endIcon",
  "fadeIn": "quizButton-module-scss-module__ykarya__fadeIn",
  "fadeOut": "quizButton-module-scss-module__ykarya__fadeOut",
  "loading": "quizButton-module-scss-module__ykarya__loading",
  "loadingText": "quizButton-module-scss-module__ykarya__loadingText",
  "primary": "quizButton-module-scss-module__ykarya__primary",
  "responsive": "quizButton-module-scss-module__ykarya__responsive",
  "scaleIn": "quizButton-module-scss-module__ykarya__scaleIn",
  "scaleOut": "quizButton-module-scss-module__ykarya__scaleOut",
  "secondary": "quizButton-module-scss-module__ykarya__secondary",
  "spinner": "quizButton-module-scss-module__ykarya__spinner",
  "startIcon": "quizButton-module-scss-module__ykarya__startIcon",
  "textContainer": "quizButton-module-scss-module__ykarya__textContainer",
  "white": "quizButton-module-scss-module__ykarya__white",
  "withIcon": "quizButton-module-scss-module__ykarya__withIcon",
  "zoomIn": "quizButton-module-scss-module__ykarya__zoomIn",
  "zoomOut": "quizButton-module-scss-module__ykarya__zoomOut",
});
